$(function () {
    //variables
    const TRANSITION = 500;
    const DEFAULT_WIDTH = 1200;
    const SECTIONS = $('.why-hire-section');

    SECTIONS.each(function () {
        const TABS = $(this).find('.why-hire-tabs');
        const SUB_TITLES = $(this).find('.why-hire-tabs__title');
        const TABS_ITEMS = $(this).find('.why-hire-tabs__item');
        let IS_ANIMATED = !getAccessibilitySettingsFromStorage()['without-animation'];
        let screen = window.innerWidth;

        //events
        TABS.click(toggleTab());
        if (TABS.hasClass('tabs-mode')) TABS_ITEMS.hover(toggleTabByHover);
        $(window).resize(function () {
            const width = window.innerWidth;
            if (screen !== width) {
                reset();
                normalizeSubTitles();
                initNavigationByTab();
                screen = width;
            }
        });
        $(document).on('accessibilityPreEvent', function (e) {
            IS_ANIMATED = !e.originalEvent.detail['without-animation'];
            if (!IS_ANIMATED) reset();
        });

        normalizeSubTitles();
        initNavigationByTab();

        //functions
        function toggleTab(e) {
            let prevTab = $(null);

            return (e) => {
                if (window.innerWidth < DEFAULT_WIDTH && IS_ANIMATED) {
                    const eventTarget = $(e.target);
                    const currTab = eventTarget.closest('.why-hire-tabs__item')
                    const btn = currTab.find('.why-hire-tabs__toggler');
                    const isActive = btn.hasClass('active');

                    if (currTab.length) {
                        btn.toggleClass('active');
                        
                        if (currTab.get(0) !== prevTab.get(0)) {
                            prevTab.find('.why-hire-tabs__toggler').removeClass('active');
                            prevTab.find('.why-hire-tabs__content').stop().animate({
                                height: 0
                            }, TRANSITION, function () {
                                $(this).css({height: ''});
                            });
                        }

                        currTab.find('.why-hire-tabs__content').stop().animate({
                            height: !isActive ? currTab.find('.why-hire-tabs__content-container').outerHeight() : 1
                        }, TRANSITION, function () {
                            if (isActive) $(this).css({height: ''});
                            prevTab = currTab;
                        });
                    }
                }
            }
        }

        function toggleTabByHover(e) {
            if (window.innerWidth >= DEFAULT_WIDTH) {
                const currTab = $(e.target).closest('.why-hire-tabs__item');
                const isActive = e.type === 'mouseenter';

                currTab.find('.why-hire-tabs__content').stop().animate({
                    height: isActive ? currTab.find('.why-hire-tabs__content-container').outerHeight() : 0
                }, TRANSITION - 200, function () {
                    if (!isActive) $(this).css({height: ''});
                });
            }
        }

        function reset() {
            TABS.find('.why-hire-tabs__toggler').removeClass('active');
            TABS.find('.why-hire-tabs__content').css({height: ''});
        }

        function normalizeSubTitles() {
            if (window.innerWidth >= DEFAULT_WIDTH) {
                let minHeight = 0;

                SUB_TITLES.outerHeight(function (index, height) {
                    if (height > minHeight) minHeight = height;
                });

                SUB_TITLES.css({minHeight});
            } else SUB_TITLES.css({minHeight: ''});
        }

        function initNavigationByTab() {
            if (window.innerWidth >= DEFAULT_WIDTH) {
                TABS_ITEMS.attr('tabindex', 0);
            } else TABS_ITEMS.removeAttr('tabindex');
        }
    });
});
